const win = /** @type {any} */ (window);
if (!win.__productCardAnimations) {
  win.__productCardAnimations = true;

  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('card-visible');
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0, rootMargin: '0px 0px 80px 0px' }
    );

    /** @param {NodeListOf<Element> | Element[]} cards */
    function observeBatch(cards) {
      let batchIndex = 0;
      for (const card of cards) {
        if (card.classList.contains('card-visible') || card.classList.contains('is-animate-card')) continue;

        // If already in the viewport, mark visible right away — no animation needed
        const rect = card.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          card.classList.add('card-visible');
          continue;
        }

        if (card instanceof HTMLElement) card.style.setProperty('--card-animation-delay', `${batchIndex * 60}ms`);
        card.classList.add('is-animate-card');
        observer.observe(card);
        batchIndex++;
      }
    }

    observeBatch(document.querySelectorAll('product-card'));

    // Pick up cards added dynamically (infinite scroll / load more / recommendations)
    new MutationObserver((mutations) => {
      const newCards = [];
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches('product-card')) newCards.push(node);
          newCards.push(...node.querySelectorAll('product-card'));
        }
      }
      if (newCards.length) observeBatch(newCards);
    }).observe(document.body, { childList: true, subtree: true });
  }
}
